import moment from 'moment';
import { getOffsetByFormatType, TimeFormatType } from '../../../../../../common/components/TimeFormat/TimeFormat';
import {
  AGGREGATION_INTERVAL_10MIN,
  AGGREGATION_INTERVAL_15S,
  AGGREGATION_INTERVAL_1D,
  AGGREGATION_INTERVAL_1H,
  AGGREGATION_INTERVAL_1MIN,
  AGGREGATION_INTERVAL_1W,
} from '../../const';

export const aggregationOptions = [
  { value: 'avg', label: 'Avg' },
  { value: 'max', label: 'Max' },
  { value: 'min', label: 'Min' },
  { value: 'sum', label: 'Sum' },
];

export const timeZoneOption = [
  { label: `${TimeFormatType.UTC} ${moment().utc().format('Z')}`, value: getOffsetByFormatType(TimeFormatType.UTC) },
  { label: `${TimeFormatType.USER} ${moment().format('Z')}`, value: getOffsetByFormatType(TimeFormatType.USER) },
];

export const realTimeRangeOptions = [
  { value: 1, label: '1 hour' },
  { value: 2, label: '2 hours' },
  { value: 3, label: '3 hours' },
];

export const historyRangeOptions = [
  { value: 'auto', label: 'Auto' },
  { value: AGGREGATION_INTERVAL_15S, label: '15 sec' },
  { value: AGGREGATION_INTERVAL_1MIN, label: '1 minute' },
  { value: AGGREGATION_INTERVAL_10MIN, label: '10 minutes' },
  { value: AGGREGATION_INTERVAL_1H, label: '1 hour' },
  { value: AGGREGATION_INTERVAL_1D, label: '1 day' },
  { value: AGGREGATION_INTERVAL_1W, label: '1 week' },
];
